import * as React from 'react';
import { visualize, story, snap } from 'storybook-snapper';
import { WeeklyDateNavigation } from '..';
import { TPAComponentsProvider } from '../TPAComponentsConfig';
import { classes } from './WeeklyDateNavigation.visual.st.css';
import { EditorShell, VisualAsync } from '../../test/visual/VisualAsync';
import {
  WeeklyDateNavigationDriver,
  weeklyDateNavigationDriverFactory,
} from './WeeklyDateNavigation.driver';

const VisualTestWeeklyDateNavigation = (props) => {
  const { width, ...rest } = props;

  return (
    <EditorShell>
      <div style={{ width }}>
        <WeeklyDateNavigation {...rest} />
      </div>
    </EditorShell>
  );
};

visualize('WeeklyDateNavigation', () => {
  story('simple', () => {
    snap(
      'default props',
      <VisualTestWeeklyDateNavigation
        width="280px"
        onChange={() => {}}
        value={{
          startOfWeek: new Date('2021-07-12'),
          endOfWeek: new Date('2021-07-18'),
        }}
      />,
    );
    snap(
      'responsiveness',
      <VisualTestWeeklyDateNavigation
        width="600px"
        onChange={() => {}}
        value={{
          startOfWeek: new Date('2021-07-12'),
          endOfWeek: new Date('2021-07-18'),
        }}
      />,
    );
    snap(
      'Dates at different months',
      <VisualTestWeeklyDateNavigation
        width="280px"
        onChange={() => {}}
        value={{
          startOfWeek: new Date('2021-12-26'),
          endOfWeek: new Date('2022-01-01'),
        }}
      />,
    );
    snap(
      'Adaptive to font change',
      <VisualTestWeeklyDateNavigation
        className={classes.fontSizeOverride}
        width="650px"
        onChange={() => {}}
        value={{
          startOfWeek: new Date('2021-12-26'),
          endOfWeek: new Date('2022-01-01'),
        }}
      />,
    );
    snap(
      'Adaptive to background color change',
      <VisualTestWeeklyDateNavigation
        className={classes.backgroundColorOverride}
        width="280px"
        onChange={() => {}}
        value={{
          startOfWeek: new Date('2021-12-26'),
          endOfWeek: new Date('2022-01-01'),
        }}
      />,
    );
    snap(
      'Adaptive to text color change',
      <VisualTestWeeklyDateNavigation
        className={classes.textColorOverride}
        width="280px"
        onChange={() => {}}
        value={{
          startOfWeek: new Date('2021-12-26'),
          endOfWeek: new Date('2022-01-01'),
        }}
      />,
    );
    snap(
      'Adaptive to arrows color change',
      <VisualTestWeeklyDateNavigation
        className={classes.arrowsColorOverride}
        width="280px"
        onChange={() => {}}
        value={{
          startOfWeek: new Date('2021-12-26'),
          endOfWeek: new Date('2022-01-01'),
        }}
      />,
    );
    snap(
      'responsive rtl',
      <div dir="rtl">
        <TPAComponentsProvider value={{ rtl: true }}>
          <VisualTestWeeklyDateNavigation
            locale="he"
            firstDayOfWeek={0}
            width="600px"
            value={{
              startOfWeek: new Date('2021-12-26'),
              endOfWeek: new Date('2022-01-01'),
            }}
            onChange={() => {}}
          />
        </TPAComponentsProvider>
      </div>,
    );
  });

  story('simple / focus', () => {
    const its = [
      {
        it: 'previous button',
        action: (driver: WeeklyDateNavigationDriver) =>
          driver.clickOnPrevWeekButton(),
      },
      {
        it: 'next button',
        action: (driver: WeeklyDateNavigationDriver) =>
          driver.clickOnNextWeekButton(),
      },
    ];
    its.forEach(({ it, action }) =>
      snap(it, (done) => (
        <VisualAsync
          driverFactory={weeklyDateNavigationDriverFactory}
          onDone={done}
          action={action}
        >
          <WeeklyDateNavigation
            onChange={() => {}}
            value={{
              startOfWeek: new Date('2021-07-12'),
              endOfWeek: new Date('2021-07-18'),
            }}
          />
        </VisualAsync>
      )),
    );
  });

  story('with wst variables', () => {
    snap('default', () => {
      const style = {
        '--wst-paragraph-2-color-rgb': '0,0,150',
        '--wst-paragraph-2-font-family': 'Courier New',
        '--wst-primary-background-color-rgb': '240,180,180',
      } as React.CSSProperties;

      return (
        <div style={style}>
          <VisualTestWeeklyDateNavigation
            width="280px"
            value={{
              startOfWeek: new Date('2021-07-12'),
              endOfWeek: new Date('2021-07-18'),
            }}
          />
        </div>
      );
    });
    snap('font', () => {
      const style = {
        '--wst-paragraph-2-color-rgb': '0,100,0',
        '--wst-paragraph-2-font-family': 'Libre Baskerville',
        '--wst-paragraph-2-font-size': '22px',
        '--wst-paragraph-2-line-height': '3',
        '--wst-paragraph-2-font-weight': '900',
        '--wst-paragraph-2-font-style': 'italic',
        '--wst-paragraph-2-font-variant': 'small-caps',
      } as React.CSSProperties;

      return (
        <div style={style}>
          <VisualTestWeeklyDateNavigation
            width="280px"
            value={{
              startOfWeek: new Date('2021-07-12'),
              endOfWeek: new Date('2021-07-18'),
            }}
          />
        </div>
      );
    });
  });
});
